<template>
  <div class="route-search-inputs">
    <div>
      <div class="departure-area">
        <div class="input-box">
          <InputBox
            text="出発地"
            v-model="inputDeparture"
            @keydown="onClickSearch"
          />
          <div class="current-spot" @click="onClickGeo">
            <img
              src="@/assets/arrow.svg"
              alt="現在地"
              width="20px"
              height="20px"
            />
          </div>
        </div>
      </div>
      <div class="input-box">
        <InputBox
          text="目的地"
          v-model="inputDestionation"
          @keydown="onClickSearch"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import TextLinkInline from "@/components/Atoms/TextLinkInline";
import InputBox from "@/components/Atoms/InputBox";

export default {
  name: "route-search-inputs",
  components: {
    TextLinkInline,
    InputBox,
  },
  computed: {
    inputCheck() {
      return !!(this.inputDeparture !== "" && this.inputDestionation !== "");
    },
  },
  data() {
    return {
      inputDeparture: "",
      inputDestionation: "",
    };
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini", "setCurrentLatLng"]),
    onClickGeo() {
      this.loadingStartMini();
      let setCurrentLatLng = this.setCurrentLatLng;
      let loadingEndMini = this.loadingEndMini;
      navigator.geolocation.getCurrentPosition(
        function (position) {
          setCurrentLatLng({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
          loadingEndMini();
        },
        function (err) {
          var msgs = [
            err.message,
            "位置情報の取得を許可されていません。",
            "位置情報の取得に失敗しました。",
            "位置情報を取得中にタイムアウトしました。",
          ];
          window.alert(msgs[err.code]);
        },
        { maximumAge: 0 },
      );
      this.inputDeparture = "現在地";
    },
    onClickSearch() {
      if (this.inputDeparture !== "" && this.inputDestionation !== "") {
        this.$emit("click-search", {
          departure: this.inputDeparture,
          destination: this.inputDestionation,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";
.route-search-inputs {
  padding: 0 0.5rem;
}

.input-box {
  width: 100%;
  position: relative;
  input {
    background: #f6f6f6;
  }
}
.current-spot {
  position: absolute;
  right: 0.5rem;
  top: 0.6rem;
}

.departure-area {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/RouteSearchInputs.vue